import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-shapes/dot-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-shapes/losange-doodle.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-shapes/star-doodle.svg';
export default {
  name: 'AnimatedForeground',
  props: {
    svgOne: {
      type: String,
      required: true
    },
    svgOneSize: {
      type: String,
      default: '16'
    },
    svgTwo: {
      type: String,
      default: null
    },
    svgTwoSize: {
      type: String,
      default: '16'
    },
    svgThree: {
      type: String,
      default: null
    },
    svgThreeSize: {
      type: String,
      default: '32'
    },
    color: {
      type: String,
      default: '#c4a282'
    }
  },
  computed: {
    icons: function icons() {
      return [{
        name: this.svgOne,
        type: 1,
        size: this.svgOneSize,
        position: ['left-top', 'left-bottom', 'right-top', 'right-bottom']
      }, {
        name: this.svgTwo,
        type: 2,
        size: this.svgTwoSize,
        position: ['left-top', 'left-bottom', 'right-top', 'right-bottom']
      }, {
        name: this.svgThree,
        type: 3,
        size: this.svgThreeSize,
        position: ['left-center', 'right-center']
      }];
    }
  },
  methods: {
    svgClass: function svgClass(type, position) {
      return "icon-".concat(type, " ").concat(position, "-icon-").concat(type);
    }
  }
};